export default __webpack_public_path__ + "static/media/Ios.9555dcd2.svg";